// Single source of truth for the launch visible/gated feature split (ADR 0025
// D1). Each key maps to a compile-time flag; un-gating a feature post-launch is a
// one-line `enabled: true` flip here, with no route or nav surgery. No env
// override for V1 (ADR 0025 Open Q1) -- a staging-vs-prod split is not needed
// until billing/entitlements exist.

export interface FeatureConfig {
  // When false, the feature's entry point(s) are hidden and its route(s) render
  // ComingSoonPage instead of the real surface (see requireFeature).
  readonly enabled: boolean;
  // Roadmap unit shown on the ComingSoon panel when the feature is gated.
  readonly plannedUnit?: string;
}

// Gated set per ADR 0024 D2: AI Q&A, broker auto-sync, and Alerts ship hidden
// behind "coming soon" at public launch. brokerSync has no UI surface yet, so it
// carries no route guard -- the key exists for audit completeness and future use.
export const FEATURES = {
  alerts: { enabled: false, plannedUnit: "post-launch" },
  aiQa: { enabled: false, plannedUnit: "post-Phase-8" },
  brokerSync: { enabled: false, plannedUnit: "post-launch" },
  // ADR 0034: the measured import progress bar. Shipped enabled in Unit 1 with
  // the full-width ImportProgressBanner; the flag stays as a kill-switch for the
  // determinate bar (off -> indeterminate spinner). No route guard -- this gates
  // a widget, not a page (brokerSync precedent).
  liveImportProgressBar: { enabled: true },
} as const satisfies Record<string, FeatureConfig>;

export type FeatureKey = keyof typeof FEATURES;

export function isFeatureEnabled(key: FeatureKey): boolean {
  return FEATURES[key].enabled;
}
